(function() {
  'use strict';

  function BasePanelCtrl() {

    function enableDisableLoading(loadingObj, loadingName, loadingSet) {
      var disableList = _.isArray(loadingName) ? loadingName : [loadingName];
      var activated = loadingSet;
      _.forEach(disableList, function(loading) {
        _.forIn(loadingObj, function(value, loadingName) {
          if (loadingName === loading) {
            loadingObj[loadingName] = activated;
          }
        });
      });
    }

    function close (mdPanelRef) {
      if(mdPanelRef) {
        mdPanelRef.close();
      }
    }

    angular.extend(this, {
      close: close,
      enableDisableLoading: enableDisableLoading
    });

  }

  angular
    .module('mandaeApp')
    .controller('BasePanelCtrl', BasePanelCtrl);
}());
